import { useEffect, useState, FC } from 'react';
import { Form, Input, Button, Select, Upload, message, InputNumber, Modal } from 'antd';
import { uploadFile, addTeacher, updateTeacher } from '@root/common/service';
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
import { SubjectSelect, TitleSelect, HospitalSelect } from '@root/components/selectBox/index';

const { Option } = Select;
const { TextArea } = Input;
message.config({ maxCount: 1 });

const labelCol = { span: 5 };
const wrapperCol = { span: 19 };

interface IProps {
    lecturerDetail?: ILecturerDetailProp,
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>,
    getTeacherList: (page?: number, params?: object) => Promise<void>
}

export interface ILecturerDetailProp {
    createBy: string,
    createTime: string,
    id: 7
    imageUrl: string,
    imageUrlAllPath: string,
    instituteId: 5772
    introduction: string,
    mobile: string,
    name: string,
    showOrder: 1
    status: 1
    subjectId: 6
    titleId: 116
    updateTime: string,
    workUnitId: 821
}

export const EditorLucturer: FC<IProps> = (props) => {
    const { lecturerDetail } = props;
    const [form] = Form.useForm();
    const [imgUrl, setImgUrl] = useState('');

    const { instituteList=[] } = useSelector(
        (state: RootState) => state.directionaries
    );

    const handleOk = () => {
        if (lecturerDetail) {
            form.validateFields().then((res: any) => {
                res.id = lecturerDetail.id;
                updateTeacher(res).then(res => {
                    message.success('修改成功');
                    props.getTeacherList();
                    props.setIsModalVisible(false);
                })
            }).catch(err => {
                message.error(err.errorFields[0].errors[0])
            })
        } else {
            form.validateFields().then((res: any) => {
                addTeacher(res).then(res => {
                    message.success('添加成功');
                    props.getTeacherList();
                    props.setIsModalVisible(false);
                })
            }).catch(err => {
                message.error(err.errorFields[0].errors[0])
            })
        }
    }

    const uploadChange = async (data: any) => {
        const { file } = data;
        
        if (file.type !== "image/jpeg" && file.type !== "image/jpg" && file.type !== "image/png") {
            message.error("请选择正确的文件");
            return false;
        }

        if (file.size / 1024 / 1024 > 2) {
            message.error("请选择正确的文件");
            return false;
        }

        let width = 0;
        let height = 0;
        const checkSize = () => {
            return new Promise((resolve, reject) => {
                let image = new Image();
                image.src = URL.createObjectURL(file);
                image.onload = function () {
                    console.log(image.width)
                    resolve({ width: image.width, height: image.height });
                };
            });
        };
        await checkSize()
            .then((res: any) => {
                width = res.width;
                height = res.height;
            })
            .catch((err) => {
                message.error("图片解析错误");
            });

        if (width !== 300 || height !== 300) {
            message.error("请上传宽300px、高300px的图片");
            return false;
        }
        let formData = new FormData();
        formData.append("file", file);
        formData.append("uploadFileType", "image");
        formData.append("folder", "teacher");

        uploadFile(formData).then(res => {
            const { url, shortUrl } = res;
            setImgUrl(shortUrl);
            form.setFieldsValue({
                imageUrl: url,
            });
        })
    }
    
    useEffect(() => {
        if (lecturerDetail) {
            form.setFieldsValue({
                name: lecturerDetail.name,
                imageUrl: lecturerDetail.imageUrl,
                mobile: lecturerDetail.mobile,
                workUnitId: lecturerDetail.workUnitId,
                subjectId: lecturerDetail.subjectId,
                titleId: lecturerDetail.titleId,
                introduction: lecturerDetail.introduction,
                showOrder: lecturerDetail.showOrder
            });
            setImgUrl(lecturerDetail.imageUrlAllPath);
        }
    }, []);

    return (
        <Modal
            title="新建讲师"
            visible={true}
            onOk={handleOk}
            onCancel={() => { props.setIsModalVisible(false) }}
        >
            <Form
                form={form}
                labelCol={labelCol}
                wrapperCol={wrapperCol}
            >
                <Form.Item label="讲师姓名"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: '请填写姓名',
                        },
                    ]}
                >
                    <Input maxLength={30} showCount={true} />
                </Form.Item>
                <Form.Item label="讲师头像"
                    name="imageUrl"
                    valuePropName="fileList"
                    rules={[
                        {
                            required: true,
                            message: "请选择讲师头像",
                        },
                    ]}
                >
                    <>
                        <Input type="hidden" />
                        { imgUrl && <img src={imgUrl} style={{maxWidth: '100%'}}/> }
                        <Upload
                            className="course-uploader"
                            showUploadList={false}
                            customRequest={uploadChange}
                        >
                            <p>* 支持2M以内JPG、PNG，请上传宽300px、高300px的图片</p>
                            <Button>
                                选择文件
                            </Button>
                        </Upload>
                    </>
                </Form.Item>
                <Form.Item label="手机号码"
                    name="mobile"
                    rules={[
                        {
                            pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
                            message: '请输入正确手机号'
                        }
                    ]}
                >
                    <InputNumber
                        style={{ width: '100%' }}
                        maxLength={11}
                        controls={false}
                    />
                </Form.Item>
                <HospitalSelect label="工作单位"
                    name="workUnitId"
                    rules={[
                        {
                            required: true,
                            message: '请选择工作单位',
                        },
                    ]}
                />
                <SubjectSelect 
                    label="学科"
                    name="subjectId"
                    rules={[
                        {
                            required: true,
                            message: '请选择学科',
                        },
                    ]}
                />
                <TitleSelect 
                    label="职称"
                    name="titleId"
                    rules={[
                        {
                            required: true,
                            message: '职称',
                        },
                    ]}
                />
                <Form.Item label="详细介绍"
                    name="introduction"
                    rules={[
                        {
                            required: true,
                            message: '请填写详细介绍',
                        },
                    ]}
                >
                    <TextArea maxLength={300} showCount={true} />
                </Form.Item>
                <Form.Item label="排序"
                    name="showOrder"
                    rules={[
                        {
                            required: true,
                            message: '请填写排序',
                        },
                    ]}
                >
                    <InputNumber maxLength={30} min={0}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}